import React from 'react';
import { CONFIG } from '../config';

export const Fonts: React.FC = () => (
  <>
    <link rel="preconnect" href={CONFIG.ASSETS_BASE_URL} />
    <link href={`${CONFIG.ASSETS_BASE_URL}/fonts3/fonts4.css`} rel="stylesheet" />
  </>
);
